export {
  buildTelegramBindDeepLink,
  getTelegramBotBaseUrl,
  getTelegramBotDisplay,
  getTelegramBotName,
  isValidTelegramBotUrl,
} from "@/helpers/telegram";

export function isTelegramLinked(user) {
  const chatId = user?.telegramChatId;
  return chatId != null && String(chatId).trim() !== "";
}

export function formatTelegramBindCommand(bindCode) {
  return `/bind ${bindCode}`;
}

export function formatCountdown(remainingMs) {
  if (remainingMs == null) {
    return "";
  }
  if (remainingMs <= 0) {
    return "Expired";
  }
  const minutes = Math.floor(remainingMs / 60000);
  const seconds = Math.floor((remainingMs % 60000) / 1000);
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
